import {
  Autocomplete,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button as MUIButton,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  DeleteSubTaskById,
  fetchSubTaskById,
  updateSubTask,
} from "../../../Redux/Slice/SubTask";
import { fetchActiveMemberData } from "../../../Redux/Slice/TaskMasterSlice";

const EditSubTask = () => {
  const { id } = useParams(); // Task ID from route
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { ActiveMemberData } = useSelector((state) => state.TaskMaster);
  const { SubTaskByIdData } = useSelector((state) => state.SubTask);
  const [showConfirmModal, setShowConfirmModal] = useState(false); // For confirmation modal visibility

  const [members, setMembers] = useState([]);
  const [selectedMemberId, setSelectedMemberId] = useState("");
  const [subTaskName, setSubTaskName] = useState("");

  useEffect(() => {
    dispatch(fetchActiveMemberData());
    dispatch(fetchSubTaskById(id));
  }, [dispatch, id]);

  useEffect(() => {
    const initialMembers = SubTaskByIdData?.data?.TeamId || [];
    setMembers(initialMembers.map((el) => ({ id: el._id, name: el.Name })));
    setSubTaskName(SubTaskByIdData?.data?.SubTaskName || "");
  }, [SubTaskByIdData]);

  const handleSelectChange = (event, newValue) => {
    setSelectedMemberId(newValue ? newValue._id : "");
  };

  const handleAddMember = () => {
    const selectedMember = ActiveMemberData?.data.find(
      (member) => member._id === selectedMemberId
    );
    if (
      selectedMember &&
      !members.some((member) => member.id === selectedMember._id)
    ) {
      setMembers([
        ...members,
        { id: selectedMember._id, name: selectedMember.Name },
      ]);
      setSelectedMemberId("");
    } else {
      toast.error("Member already added or not selected!");
    }
  };

  const handleRemoveMember = (id) => {
    // Remove member by filtering out the member with the specified ID
    setMembers(members.filter((member) => member.id !== id));
    toast.success("Member removed successfully!");
  };

  // const handleUpdate = () => {
  //   const memberIds = members.map((member) => member.id);
  //   dispatch(updateSubTask({ id, subTaskName, memberIds }));
  //   // navigate("/subtask");

  // };

  const handleUpdate = async () => {
    try {
      const memberIds = members.map((member) => member.id);
      const resultAction = await dispatch(
        updateSubTask({ id, subTaskName, memberIds })
      );

      // If you are using createAsyncThunk
      if (updateSubTask.fulfilled.match(resultAction)) {
        toast.success("Subtask updated successfully!");
        // navigate("/subtask");
      } else {
        toast.error("Failed to update subtask.");
      }
    } catch (error) {
      toast.error("An unexpected error occurred.");
    }
  };

  const handleDragStart = (e, index) => {
    e.dataTransfer.setData("text/plain", index);
  };

  const handleDrop = (e, dropIndex) => {
    e.preventDefault();
    const dragIndex = e.dataTransfer.getData("text/plain");
    const updatedMembers = [...members];
    if (dragIndex !== dropIndex.toString()) {
      const [movedMember] = updatedMembers.splice(dragIndex, 1);
      updatedMembers.splice(dropIndex, 0, movedMember);
      setMembers(updatedMembers);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDeleteTask = () => {
    dispatch(DeleteSubTaskById(id)) // ✅ Proper thunk dispatch
      .unwrap()
      .then(() => {
        toast.success("Sub Task deleted successfully!");
        setShowConfirmModal(false);
        navigate("/subtask");
      })
      .catch((error) => {
        toast.error(error || "Failed to delete Sub Task.");
      });
  };

  const handleOpenConfirmDialog = () => {
    setShowConfirmModal(true); // Open confirmation dialog
  };

  const handleCloseConfirmDialog = () => {
    setShowConfirmModal(false); // Close confirmation dialog
  };

  return (
    <>
      <div className="p-1 sm:p-6 md:p-8 bg-gray-100 min-h-full">
        <h3 className="text-xl font-bold main_title_page text-white bg-[#112A47] px-4 py-2 inline-block rounded">
          Sub Task Master
        </h3>

        <div className="Form_bg_color bg-white shadow-md rounded-xl mt-6">
          {/* Form Section */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 p-4 sm:p-6">
            {/* Sub Task Name */}
            <div>
              <label className="block mb-2 text-base sm:text-xl font-bold ">
                Sub Task Name
              </label>
              <input
                type="text"
                className="w-full px-4 py-2 border-2 border-black rounded-md shadow-sm focus:ring-0"
                placeholder="Enter Sub Task Name"
                value={subTaskName}
                onChange={(e) => setSubTaskName(e.target.value)}
              />
            </div>

            {/* Add Member */}
            <div>
              <label className="block mb-2 text-base sm:text-xl font-bold ">
                Select Member
              </label>
              <Autocomplete
                options={ActiveMemberData?.data || []}
                getOptionLabel={(option) => option.Name || ""}
                value={
                  ActiveMemberData?.data?.find(
                    (t) => t._id === selectedMemberId
                  ) || null
                }
                onChange={handleSelectChange}
                isOptionEqualToValue={(option, value) =>
                  option._id === value._id
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Select a member"
                    variant="outlined"
                    size="small"
                    fullWidth
                    className="!mb-2"
                  />
                )}
              />

              <div className="mt-3 flex justify-end">
                <button
                  className="bg-[#112A47] text-white px-4 py-2 rounded hover:bg-[#0c2545]"
                  onClick={handleAddMember}
                >
                  Add
                </button>
              </div>
            </div>
          </div>

          {/* Select Member */}
          <div className="mt-6 p-4 sm:p-6">
            <h3 className="my-2 font-semibold text-base sm:text-lg">
              Members List
            </h3>

            <div className="border border-dashed p-4 rounded min-h-[50px] grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4">
              {members.length > 0 ? (
                members.map((member, index) => (
                  <div
                    key={member.id}
                    draggable
                    onDragStart={(e) => handleDragStart(e, index)}
                    onDrop={(e) => handleDrop(e, index)}
                    onDragOver={handleDragOver}
                    className="flex justify-between items-center p-2 my-1 border border-gray-300 bg-gray-50 rounded-md cursor-grab"
                  >
                    <span className="text-sm md:text-base text-gray-800">
                      {member.name}
                    </span>
                    <button
                      onClick={() => handleRemoveMember(member.id)}
                      className="bg-red-500 hover:bg-red-600 text-white text-sm px-3 py-1 rounded"
                    >
                      Remove
                    </button>
                  </div>
                ))
              ) : (
                <p className="text-gray-500">No members available.</p>
              )}
            </div>
          </div>

          {/* Footer Buttons */}
          <div className="mt-6 px-4 sm:px-6 pb-6 flex flex-col sm:flex-row justify-end gap-3 sm:gap-4">
            <button
              className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 w-full sm:w-auto"
              onClick={handleOpenConfirmDialog}
            >
              Remove Task
            </button>
            <button
              onClick={handleUpdate}
              className="bg-[#112A47] text-white px-4 py-2 rounded hover:bg-[#0c2545] w-full sm:w-auto"
            >
              Update
            </button>
          </div>

          {/* Confirmation Dialog */}
          <Dialog
            open={showConfirmModal}
            onClose={handleCloseConfirmDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {"Are you sure you want to delete this task?"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                Are you sure you want to delete the Sub Task?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <MUIButton onClick={handleCloseConfirmDialog} color="primary">
                Cancel
              </MUIButton>
              <MUIButton onClick={handleDeleteTask} color="secondary" autoFocus>
                Delete
              </MUIButton>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    </>
  );
};

export default EditSubTask;
